import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseUrlInterceptor } from '@core/interceptors/base-url.interceptor';
import { ParamInterceptor } from '@core/interceptors/param-interceptor';
import { AppInitService } from '@core/services/app-init.service';
import { HttpErrorInterceptor } from '@core/interceptors/http-error-interceptor';
import { LoadingInterceptor } from '@core/interceptors/loading-interceptor';

export function initApp(appInitService: AppInitService) {
  return () => appInitService.initApp();
}

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseUrlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ParamInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      multi: true,
      deps: [AppInitService],
    },
    DatePipe,
    DecimalPipe,
  ],
})
export class CoreModule {}
